import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close_3nbqP",
  "use": "close_3nbqP-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" id=\"close_3nbqP\"> <g fillrule=\"evenodd\"> <path d=\"M10.314 -3.686H12.314V26.314H10.314z\" transform=\"rotate(-45 11.314 11.314)\" /> <path d=\"M10.314 -3.686H12.314V26.314H10.314z\" transform=\"rotate(45 11.314 11.314)\" /> </g> </symbol>"
});
var result = sprite.add(symbol);
export default symbol